import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import ReactGA from 'react-ga4';
import AuthShell from '../components/AuthShell';
import { POST_LOGIN_REDIRECT_KEY, postLoginDestination } from '../services/api';

const AuthCallbackPage = () => {
  const [searchParams] = useSearchParams();
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');
    const isNewUser = searchParams.get('is_new_user') === 'true';

    if (!token) {
      navigate('/error?code=google_auth', { replace: true });
      return;
    }

    login(token);

    if (isNewUser) {
      ReactGA.event({ category: 'User', action: 'sign_up', label: 'google' });
    } else {
      ReactGA.event({ category: 'User', action: 'login', label: 'google' });
    }

    window.postMessage(
      { type: 'NEXAURA_AUTH_TOKEN', token },
      window.location.origin
    );

    const stashed = localStorage.getItem(POST_LOGIN_REDIRECT_KEY);
    localStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
    navigate(postLoginDestination(stashed));
  }, [login, navigate, searchParams]);

  return (
    <AuthShell display="One moment.">
        <p className="auth-wait">Signing you in...</p>
    </AuthShell>
  );
};

export default AuthCallbackPage;